'use strict';

import Model from './model.js';
import axios from 'axios';

export default class Holiday extends Model {
    urlRoot() { return '/Holidays'; }

    constructor() {
        super(...arguments);
        this.softDelete = false;
    }

    constraints() {
        return {
            title: {presence: {message: '^Title is required'}},
            date: {presence: {message: '^Date is required'}},
        };
    }

    initialize() {
        this.idAttribute = 'objectId';
        super.initialize(...arguments);
        this._enabled = (typeof this.get('enabled') !== 'undefined') ?
            this.get('enabled') : true;
        this._toggle = (typeof this.get('enabled') !== 'undefined') ?
            this.get('enabled') : true;
        this._location = null;
        return this;
    }

    toggle(value, location) {
        if (value !== this._enabled) {
            return axios.post(this.finalUrl() + '/toggle', {
                companyId: app.company.id,
                locationId: location && location.id,
                holidayId: this.id,
                enabled: value
            }, {headers: {'Authorization': app.user.getAccessToken().id}})
            .then(() => {
                this._enabled = value;
                this._toggle = value;

                return true;
            })
            .catch(() => {
                return false;
            });
        }

        return Promise.resolve(false);
    }

    dirty() {
        const dirty = super.dirty(...arguments);
        if (arguments.length) {
            return dirty;
        }
        return dirty || (this._enabled !== this._toggle);
    }

    isEnabled() {
        return (this._toggle === true);
    }

    save() {
        if (this.get('companyId')) {
            return super.save(...arguments);
        }

        return Promise.resolve();
    }
}



// WEBPACK FOOTER //
// ./app/new-models/holiday.js